import React from "react";
import Table from "./Table"
import { convertApiHeaderToReactTableHeader } from "./UtilFunctions";

function CustomReports() {

    const dataTypes = [
        { id: 0, apiType: "Default", frontType: "", frontDisplayFormat: "" },
        { id: 1, apiType: "Integer", frontType: "number", frontDisplayFormat: "" },
        { id: 2, apiType: "Double", frontType: "number", frontDisplayFormat: "" },
        { id: 3, apiType: "Date", frontType: "date", frontDisplayFormat: "YYYY-MM-DD HH:mm:ss", sourceDisplayFormat: "YYYY-MM-DDTHH:mm:ss" },
        { id: 4, apiType: "String", frontType: "string", frontDisplayFormat: "" },
        { id: 5, apiType: "yyyyMMdd", frontType: "date", frontDisplayFormat: "YYYY-MM-DD", sourceDisplayFormat: "YYYYMMDD" },
        { id: 6, apiType: "Boolean", frontType: "boolean", frontDisplayFormat: "" },
        { id: 7, apiType: "IntegerTime", frontType: "date", frontDisplayFormat: "HH:mm:ss", sourceDisplayFormat: "s" },
        { id: 8, apiType: "yyyyMM", frontType: "date", frontDisplayFormat: "MMM YYYY", sourceDisplayFormat: "YYYYMM" }
      ];

    const columns = React.useMemo(
        () => [
            {
                id: "1",
                Header: "Company",
                accessor: "company",
                show : true,
            },
            {
                id: "2",
                Header: "Incoming Calls",
                accessor: "incomingCalls",
                show : true
            },
            {
                id: "3",
                Header: "Incoming Calls Distinct ExternalP",
                accessor: "incomingCallsDistinctExternalP",
                show : false
            },
            {
                id: "4",
                Header: "Incoming Calls Duration",
                accessor: "incomingCallsDuration",
                show : false
            },
            {
                id: "5",
                Header: "Outgoing Calls",
                accessor: "outgoingCalls",
                show : false
            },
            {
                id: "6",
                Header: "Outgoing Calls Distinct ExternalP",
                accessor: "outgoingCallsDistinctExternalP",
                show : false
            },
            {
                id: "7",
                Header: "Outgoing Calls Duration",
                accessor: "outgoingCallsDuration",
                show : false
            },
            {
                id: "8",
                Header: "Total Calls",
                accessor: "totalCalls",
                show : false
            },
            {
                id: "9",
                Header: "Total Calls Distinct ExternalP",
                accessor: "totalCallsDuration",
                show : false
            },
            {
                id: "10",
                Header: "Total Calls Distinct ExternalP",
                accessor: "totalCallsDistinctExternalP",
                show : false
            },
        ],
        []
    );



    interface Data {
        company: string;
        incomingCalls: number;
        incomingCallsDistinctExternalP: number;
        incomingCallsDuration: string;
        outgoingCalls: number;
        outgoingCallsDistinctExternalP: number;
        outgoingCallsDuration: string;
        totalCalls: number;
        totalCallsDuration: number;
        totalCallsDistinctExternalP: string;
    }

    //const data: Data[] = React.useMemo(() => makeData(10), []);

    const data: Data[] = [
        {
            company: "RTEL S.A.",
            incomingCalls: 221,
            incomingCallsDistinctExternalP: 65,
            incomingCallsDuration: "04:54:17",
            outgoingCalls: 275,
            outgoingCallsDistinctExternalP: 86,
            outgoingCallsDuration: "05:29:51",
            totalCalls: 496,
            totalCallsDuration: 120,
            totalCallsDistinctExternalP: "10:24:08",
        },
        {
            company: "UNKNOWN",
            incomingCalls: 286,
            incomingCallsDistinctExternalP: 114,
            incomingCallsDuration: "04:11:26",
            outgoingCalls: 275,
            outgoingCallsDistinctExternalP: 98,
            outgoingCallsDuration: "UNKNOWN",
            totalCalls: 459,
            totalCallsDuration: 181,
            totalCallsDistinctExternalP: "07:06:13",
        },
        {
            company: "Test 1",
            incomingCalls: 431,
            incomingCallsDistinctExternalP: 235235,
            incomingCallsDuration: "07:11:26",
            outgoingCalls: 464,
            outgoingCallsDistinctExternalP: 98,
            outgoingCallsDuration: "UNKNOWN",
            totalCalls: 754,
            totalCallsDuration: 254,
            totalCallsDistinctExternalP: "10:06:13",
        },
        {
            company: "Test 2",
            incomingCalls: 131,
            incomingCallsDistinctExternalP: 24,
            incomingCallsDuration: "07:11:26",
            outgoingCalls: 143,
            outgoingCallsDistinctExternalP: 23,
            outgoingCallsDuration: "UNKNOWN",
            totalCalls: 755,
            totalCallsDuration: 126,
            totalCallsDistinctExternalP: "02:06:13",
        },
        {
            company: "Test 3",
            incomingCalls: 354,
            incomingCallsDistinctExternalP: 655,
            incomingCallsDuration: "05:11:26",
            outgoingCalls: 866,
            outgoingCallsDistinctExternalP: 65,
            outgoingCallsDuration: "UNKNOWN",
            totalCalls: 975,
            totalCallsDuration: 564,
            totalCallsDistinctExternalP: "09:36:13",
        },
        {
            company: "Test 4",
            incomingCalls: 234,
            incomingCallsDistinctExternalP: 253,
            incomingCallsDuration: "05:11:26",
            outgoingCalls: 476,
            outgoingCallsDistinctExternalP: 456,
            outgoingCallsDuration: "UNKNOWN",
            totalCalls: 675,
            totalCallsDuration: 234,
            totalCallsDistinctExternalP: "15:20:13",
        },
        {
            company: "Test 5",
            incomingCalls: 456,
            incomingCallsDistinctExternalP: 432,
            incomingCallsDuration: "08:11:26",
            outgoingCalls: 754,
            outgoingCallsDistinctExternalP: 233,
            outgoingCallsDuration: "UNKNOWN",
            totalCalls: 432,
            totalCallsDuration: 123,
            totalCallsDistinctExternalP: "05:10:13",
        },
        {
            company: "Test 6",
            incomingCalls: 129,
            incomingCallsDistinctExternalP: 265,
            incomingCallsDuration: "15:11:26",
            outgoingCalls: 250,
            outgoingCallsDistinctExternalP: 366,
            outgoingCallsDuration: "UNKNOWN",
            totalCalls: 125,
            totalCallsDuration: 189,
            totalCallsDistinctExternalP: "20:10:13",
        },
        {
            company: "Test 7",
            incomingCalls: 299,
            incomingCallsDistinctExternalP: 175,
            incomingCallsDuration: "07:40:26",
            outgoingCalls: 180,
            outgoingCallsDistinctExternalP: 300,
            outgoingCallsDuration: "UNKNOWN",
            totalCalls: 150,
            totalCallsDuration: 170,
            totalCallsDistinctExternalP: "5:10:13",
        },
        {
            company: "Test 8",
            incomingCalls: 300,
            incomingCallsDistinctExternalP: 252,
            incomingCallsDuration: "08:25:26",
            outgoingCalls: 85,
            outgoingCallsDistinctExternalP: 658,
            outgoingCallsDuration: "UNKNOWN",
            totalCalls: 200,
            totalCallsDuration: 458,
            totalCallsDistinctExternalP: "7:10:13",
        },
        {
            company: "Test 9",
            incomingCalls: 123,
            incomingCallsDistinctExternalP: 144,
            incomingCallsDuration: "02:25:26",
            outgoingCalls: 24,
            outgoingCallsDistinctExternalP: 234,
            outgoingCallsDuration: "UNKNOWN",
            totalCalls: 564,
            totalCallsDuration: 123,
            totalCallsDistinctExternalP: "9:50:13",
        },
        {
            company: "Test 10",
            incomingCalls: 345,
            incomingCallsDistinctExternalP: 567,
            incomingCallsDuration: "08:25:26",
            outgoingCalls: 344,
            outgoingCallsDistinctExternalP: 455,
            outgoingCallsDuration: "UNKNOWN",
            totalCalls: 645,
            totalCallsDuration: 344,
            totalCallsDistinctExternalP: "15:20:13",
        },
        {
            company: "Test 11",
            incomingCalls: 255,
            incomingCallsDistinctExternalP: 366,
            incomingCallsDuration: "18:25:26",
            outgoingCalls: 250,
            outgoingCallsDistinctExternalP: 300,
            outgoingCallsDuration: "UNKNOWN",
            totalCalls: 400,
            totalCallsDuration: 256,
            totalCallsDistinctExternalP: "07:36:00",
        },
        /*{
          company: "Total",
          incomingCalls: 286,
          incomingCallsDistinctExternalP: 114,
          incomingCallsDuration: "04:11:26",
          outgoingCalls: 275,
          outgoingCallsDistinctExternalP: 98,
          outgoingCallsDuration: "UNKNOWN",
          totalCalls: 459,
          totalCallsDuration: 181,
          totalCallsDistinctExternalP: "07:06:13",
        },*/
    ];
    

    return <>
        <Table columns={convertApiHeaderToReactTableHeader(columns, dataTypes)} data={data} noDataFoundTitle="No data yet"defaultOrderByKeyFilter=""  />;
    </>
}

export default CustomReports;
